<template>
  <div>
    <div class="space-y-4">
      <div class="flex justify-between">
        <h2 class="font-semibold uppercase text-gray-600">Vehicle type</h2>
      </div>
      <div class="space-y-8">
        <router-link
          to="/vehicle-types/add"
          class="px-4 py-2 bg-blue-500 text-white font-semibold rounded hover:bg-blue-700"
        >
          Add Vehicle Type
        </router-link>
      </div>

      <div class="inline-block min-w-full shadow rounded-lg mt-4">
        <table class="min-w-full leading-normal">
          <thead>
            <tr>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Name
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Image
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Base Fare
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Price Per KM
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Price Per MIN
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Number of seats
              </th>

              <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100"></th>
            </tr>
          </thead>
          <tbody class="relative" v-if="vehicleTypes.length">
            <tr
              v-for="(vehicleType, index) in vehicleTypes"
              :key="vehicleType._id"
            >
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="whitespace-no-wrap">{{ vehicleType.name }}</p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <img
                  class="rounded-lg object-cover h-16 w-16"
                  :src="
                    vehicleType.photo ||
                    'https://img.pngio.com/error-inoperative-invalid-none-nothing-null-void-icon-nothing-png-512_512.png'
                  "
                />
              </td>

              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">
                  {{ vehicleType.baseFare || "-" }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                {{ vehicleType.pricePerKM || "0.0" }}
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                {{ vehicleType.pricePerMin || "0.0" }}
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                {{ vehicleType.numberOfSeats || "0.0" }}
              </td>
              <td
                class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-right"
              >
                <div class="relative inline-block text-left">
                  <div>
                    <span class="rounded-md shadow-sm">
                      <button
                        @click="toggleDropdown(index)"
                        type="button"
                        class="inline-flex justify-center w-full rounded-md px-4 py-2 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
                        aria-haspopup="true"
                        :aria-expanded="openDropdown === index"
                      >
                        <i class="material-icons">more_vert</i>
                      </button>
                    </span>
                  </div>
                  <transition
                    enter-active-class="transition ease-out duration-100"
                    enter-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95"
                  >
                    <div
                      v-if="openDropdown === index"
                      class="origin-top-right absolute right-0 w-56 rounded-md shadow-lg z-30"
                    >
                      <div
                        class="rounded-md bg-white shadow-xs"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="options-menu"
                      >
                        <div class="border-t border-gray-100"></div>
                        <div class="py-1">
                          <router-link
                            :to="`/vehicle-types/${vehicleType._id}/edit`"
                            class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                            role="menuitem"
                          >
                            Edit
                          </router-link>
                        </div>
                        <div class="border-t border-gray-100"></div>
                        <div class="py-1">
                          <button
                            type="button"
                            @click="openConfirmBox"
                            class="block w-full text-left px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                            role="menuitem"
                          >
                            <span>Delete</span>
                            <portal to="modals">
                              <transition
                                enter-active-class="transition ease-out duration-100"
                                enter-class="transform opacity-0 scale-95"
                                enter-to-class="transform opacity-100 scale-100"
                                leave-active-class="transition ease-in duration-75"
                                leave-class="transform opacity-100 scale-100"
                                leave-to-class="transform opacity-0 scale-95"
                              >
                                <div
                                  v-if="confirmOpen"
                                  @click="closeConfirmBox"
                                  class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-25 z-40"
                                >
                                  <div
                                    @click.stop
                                    class="bg-white w-full max-w-lg rounded-lg overflow-hidden shadow-lg"
                                  >
                                    <div class="bg-gray-100">
                                      <h3
                                        class="px-6 py-4 font-semibold text-gray-600"
                                      >
                                        Confirm Delete
                                      </h3>
                                    </div>
                                    <div
                                      class="flex items-center space-x-4 px-6 py-6"
                                    >
                                      <i class="material-icons text-4xl">
                                        warning
                                      </i>
                                      <div>
                                        <p>
                                          Are you sure you want to delete this
                                          driver?
                                        </p>
                                        <p>
                                          <em class="text-gray-600 text-sm">
                                            This action can not be undone!
                                          </em>
                                        </p>
                                      </div>
                                    </div>
                                    <hr />
                                    <div
                                      class="flex items-end justify-between px-6 py-4"
                                    >
                                      <button
                                        @click="closeConfirmBox"
                                        type="button"
                                        class="px-4 py-2 text-gray-600 hover:text-gray-900"
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        @click="remove(index)"
                                        type="button"
                                        :disabled="deleting"
                                        class="flex items-center space-x-2 px-4 py-2 font-semibold border border-transparent rounded shadow-sm"
                                        :class="
                                          deleting
                                            ? 'bg-red-100 text-red-500 cursor-not-allowed'
                                            : 'bg-red-200 text-red-700 hover:text-red-800 hover:border-red-800'
                                        "
                                      >
                                        <i
                                          v-if="deleting"
                                          class="material-icons spin text-red-700"
                                        >
                                          sync
                                        </i>
                                        <i v-else class="material-icons">
                                          delete
                                        </i>
                                        <span>Delete</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </transition>
                            </portal>
                          </button>
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>
              </td>
            </tr>
            <div
              v-if="loading"
              class="absolute inset-0 h-full w-full flex items-center justify-center bg-black bg-opacity-25"
            >
              <i class="material-icons text-6xl spin">sync</i>
              <span class="block invisible">Loading...</span>
            </div>
          </tbody>
          <tbody v-else>
            <tr>
              <td
                colspan="7"
                class="bg-white py-4 text-center text-gray-600 font-semibold"
              >
                <div v-if="loading" class="inline-block">
                  <i class="material-icons text-6xl spin">sync</i>
                  <span class="block invisible">Loading...</span>
                </div>
                <div v-else class="inline-block">
                  <i class="material-icons text-6xl">warning</i>
                  <span class="block">No vehicle types found!</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex justify-between items-end">
        <p class="text-gray-600">
          Showing <strong>{{ start }}</strong> to <strong>{{ end }}</strong> of
          <strong>{{ paginator.count }}</strong> entries
        </p>
        <div class="flex items-center space-x-4">
          <div>
            Per page:
            <select
              class="form-select"
              name="perPage"
              id="perPage"
              @change="setPerPage"
            >
              <option :selected="perPage === '10'" value="10">10</option>
              <option :selected="perPage === '25'" value="25">25</option>
              <option :selected="perPage === '50'" value="50">50</option>
              <option :selected="perPage === '100'" value="100">100</option>
            </select>
          </div>
          <div class="space-x-2 flex">
            <button
              @click="goToPrev"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_left</i>
            </button>
            <button
              v-for="page in total"
              :key="`pageLink-${page}`"
              type="button"
              class="p-2"
              :class="{
                'text-gray-500 hover:text-gray-800': currentPage !== page,
                'text-gray-900': currentPage === page,
              }"
              :disabled="currentPage === page"
              @click="goToPage(page)"
            >
              {{ page }}
            </button>
            <button
              @click="goToNext"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_right</i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/mixins/Pagination";

export default {
  mixins: [Pagination],
  data() {
    return {
      vehicleTypes: [],
      openDropdown: false,
      loading: true,
      confirmOpen: false,
      deleting: false,
    };
  },
  created() {
    this.getVehicleTypes();
  },
  watch: {
    currentPage() {
      this.getVehicleTypes();
    },
  },
  methods: {
    toggleDropdown(index) {
      if (this.openDropdown === index) {
        this.openDropdown = false;
      } else {
        this.openDropdown = index;
      }
    },
    getVehicleTypes() {
      this.loading = true;
      this.$http
        .get(`vehicleTypes?page=${this.currentPage}`)
        .then(response => {
          this.vehicleTypes = response.data.data;
          this.paginator = {
            nextPage: response.data.nextPage,
            prevPage: response.data.prevPage,
            count: response.data.count,
          };
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    openConfirmBox() {
      this.confirmOpen = true;
    },
    closeConfirmBox() {
      this.confirmOpen = false;
    },
    remove(index) {
      this.deleting = true;
      this.$http
        .delete(`/vehicleTypes/${this.vehicleTypes[index]._id}`)
        .then(() => {
          this.vehicleTypes.splice(index, 1);
          window.flash({ type: "success", body: "Vehicle type deleted!" });
          this.openDropdown = false;
        })
        .catch(() => {
          window.flash({
            type: "error",
            body: "Vehicle type couldn't be deleted!",
          });
        })
        .finally(() => {
          this.deleting = false;
          this.openDropdown = false;
          this.confirmOpen = false;
        });
    },
  },
};
</script>
